import { useEffect, useState } from "react";
import DoneModal from "../dashboard/doneModal";
import clockIcon from "../../images/clockIcon.svg";
import trashIcon from "../../images/trashIcon.svg";
import checkCircleIcon from "../../images/checkCircleIcon.svg";
import editIcon from "../../images/editIcon.svg";
import ReminderPopup from "../reminderPopup/reminderPopup";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import { resources_EN } from "../componentUtils";
import { PostService } from "../../services/genericPostService";
import { Path } from "../../RoutesUtils";

const ScheduleCard = ({
  sched_image,
  sched_name,
  isPage = false,
  sched_start_time,
  sched_end_time,
  sched_id,
  getTasks,
  sched_date,
  sched_desc,
  getHomeData,
  sched_status,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReminderOpen, setIsReminderOpen] = useState(false);

  const userId = localStorage.getItem("userId");

  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    }
  }, []);

  const doneTask = () => {
    const data = {
      sched_id: sched_id,
      user_id: userId,
    };

    const url = "/fmeApi/schedule_done.php";
    PostService(url, data, modal);
  };

  /* Confirmation Modal */
  const doneModal = () => {
    Swal.fire({
      title: "Er du sikker?",
      text: "Har du løst din opgave?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Opgave afsluttet",
    }).then((result) => {
      if (result.isConfirmed) {
        doneTask();
      }
    });
  };

  /* Generic Modal */
  const modal = (icon, title, message) => {
    if (icon === resources_EN.success) {
      setIsModalOpen(true);
    } else {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
      });
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    getHomeData();
  };

  /* Confirmation Modal */
  const confirmationModal = () => {
    Swal.fire({
      title: "Er du sikker?",
      text: "Du vil ikke kunne fortryde dette!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ja, slet det!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteScheduler();
      }
    });
  };

  const deleteScheduler = () => {
    const data = {
      user_id: userId,
      sched_id: sched_id,
    };
    const url = "/fmeApi/delete_scheduler.php";
    PostService(url, data, deleteModalSuccess);
  };

  /* Generic Modal */
  const deleteModalSuccess = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    }).then((response) => {
      if (response.isConfirmed && icon === resources_EN.success) {
        getHomeData();
      }
    });
  };

  return (
    <>
      <div className="bg-theme rounded-xl p-4 overflow-hidden shadow">
        <div className="bg-white w-full h-32 p-5 rounded-lg">
          <img
            src={"../../fmeApi/" + sched_image || "/placeholder.svg"}
            alt={sched_name}
            className="w-full h-full object-contain"
          />
        </div>
        {/* <img
          src={"../../fmeApi/" + sched_image || "/placeholder.svg"}
          alt={sched_name}
          className="w-full h-32 object-cover rounded-lg"
        /> */}
        <div className="pt-4 pb-1">
          <p className="text-sm text-white mb-3">{sched_name}</p>
          <div className="flex flex-col text-md font-semibold">
            <div className="flex items-center mb-5 text-white">
              <img
                src={clockIcon}
                className="mr-1 brightness-[999] h-6 w-6"
                alt=""
              />
              {sched_start_time}-{sched_end_time}
            </div>
            {+sched_status !== 1 ? (
              <div className="flex justify-between gap-2 text-sm">
                <button
                  onClick={doneModal}
                  className="flex text-green items-center text-[12px]"
                >
                  <img src={checkCircleIcon} className="mr-1" alt="" />
                  Marker det som udført
                </button>
                <button
                  onClick={confirmationModal}
                  className="flex text-green items-center"
                >
                  <img src={trashIcon} className="mr-1" alt="" />
                  Slet
                </button>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      {/* Modal Component */}
      <DoneModal isOpen={isModalOpen} onClose={closeModal} />
      {/* Reminder Modal Component */}
      <ReminderPopup
        isOpen={isReminderOpen}
        onClose={() => setIsReminderOpen(false)}
        data={[]}
      />
    </>
  );
};

export default ScheduleCard;
